"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _filterInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _Checkbox = _interopRequireDefault(require("../Forms/Checkbox"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _FormRadioItem = _interopRequireDefault(require("../Forms/FormRadioItem"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../utils/constants");

var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _react = _interopRequireWildcard(require("react"));

var _tree = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/tree.css") : void 0);

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty2(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context5; _forEachInstanceProperty(_context5 = ownKeys(Object(source), true)).call(_context5, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context6; _forEachInstanceProperty(_context6 = ownKeys(Object(source))).call(_context6, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _tree.default);

var TreeNode = function TreeNode(_ref) {
  var _rest$parentPath, _rest$parentPath$spli, _nodePath, _nodePath$includes, _nodePath2, _nodePath3, _context, _context2, _context3, _context4, _classnames;

  var actions = _ref.actions,
      active = _ref.active,
      children = _ref.children,
      className = _ref.className,
      cssNamespace = _ref.cssNamespace,
      glyphsAfter = _ref.glyphsAfter,
      glyphsBefore = _ref.glyphsBefore,
      highlight = _ref.highlight,
      id = _ref.id,
      isNavigated = _ref.isNavigated,
      link = _ref.link,
      onExpandToggle = _ref.onExpandToggle,
      onSelectionChange = _ref.onSelectionChange,
      selectionProps = _ref.selectionProps,
      nodeData = _ref.nodeData,
      wrapContent = _ref.wrapContent,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["actions", "active", "children", "className", "cssNamespace", "glyphsAfter", "glyphsBefore", "highlight", "id", "isNavigated", "link", "onExpandToggle", "onSelectionChange", "selectionProps", "nodeData", "wrapContent"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isExpanded = _useState2[0],
      setExpanded = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isSelected = _useState4[0],
      setSelected = _useState4[1];

  var level = rest.level;
  var nodeId = "".concat((0, _useUniqueId.default)(id));
  var nodePath = (rest === null || rest === void 0 ? void 0 : (_rest$parentPath = rest.parentPath) === null || _rest$parentPath === void 0 ? void 0 : (_rest$parentPath$spli = _rest$parentPath.split) === null || _rest$parentPath$spli === void 0 ? void 0 : _rest$parentPath$spli.call(_rest$parentPath, '/')) || ['root'];

  if (!((_nodePath = nodePath) !== null && _nodePath !== void 0 && (_nodePath$includes = (0, _includes.default)(_nodePath)) !== null && _nodePath$includes !== void 0 && _nodePath$includes.call(_nodePath, nodeId)) && (_nodePath2 = nodePath) !== null && _nodePath2 !== void 0 && _nodePath2.push) {
    nodePath.push(nodeId);
  }

  nodePath = ((_nodePath3 = nodePath) === null || _nodePath3 === void 0 ? void 0 : _nodePath3.join) && nodePath.join('/');
  var nodeContentPayload = (0, _filter.default)(_context = _react.default.Children.toArray(children)).call(_context, function (child) {
    var _child$type;

    return (child === null || child === void 0 ? void 0 : (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) !== 'Tree.Node';
  });
  var nodeTextContent = (0, _find.default)(_context2 = _react.default.Children.toArray(children)).call(_context2, function (child) {
    return typeof child === 'string';
  });
  var childrenLevel = level + 1;
  var nodeChildren = (0, _map.default)(_context3 = (0, _filter.default)(_context4 = _react.default.Children.toArray(children)).call(_context4, function (child) {
    var _child$type2;

    return (child === null || child === void 0 ? void 0 : (_child$type2 = child.type) === null || _child$type2 === void 0 ? void 0 : _child$type2.displayName) === 'Tree.Node';
  })).call(_context3, function (child) {
    return /*#__PURE__*/_react.default.cloneElement(child, {
      active: active,
      level: childrenLevel,
      expansionEventBubbler: rest === null || rest === void 0 ? void 0 : rest.expansionEventBubbler,
      parentId: nodeId,
      parentPath: nodePath,
      selection: rest.selection,
      selectionPosition: rest.selectionPosition,
      treeId: rest.treeId,
      treeActive: rest === null || rest === void 0 ? void 0 : rest.treeActive
    });
  });

  var handleButtonClick = function handleButtonClick(event) {
    var _rest$expansionEventB;

    var toggledExpansionState = !isExpanded;
    rest === null || rest === void 0 ? void 0 : (_rest$expansionEventB = rest.expansionEventBubbler) === null || _rest$expansionEventB === void 0 ? void 0 : _rest$expansionEventB.call(rest, level, toggledExpansionState, nodeId, rest === null || rest === void 0 ? void 0 : rest.parentId, nodePath);
    onExpandToggle === null || onExpandToggle === void 0 ? void 0 : onExpandToggle(event, toggledExpansionState, nodeData);
    setExpanded(toggledExpansionState);
  };

  var validHighlight = function validHighlight() {
    return (0, _includes.default)(_constants.TREE_NODE_HIGHLIGHTS).call(_constants.TREE_NODE_HIGHLIGHTS, highlight);
  };

  var highlightModifier = function highlightModifier() {
    var modifier = '';

    if (validHighlight() && highlight !== 'default') {
      modifier = "--".concat(highlight);
    }

    return modifier;
  };

  var hasNavigation = !!(link !== null && link !== void 0 && (0, _trim.default)(link).call(link));
  var nodeClasses = classnames("".concat(cssNamespace, "-tree__item"), className);
  var containerClasses = classnames("".concat(cssNamespace, "-tree__item-container"), (_classnames = {}, (0, _defineProperty2.default)(_classnames, "has-highlight-indicator".concat(highlightModifier()), validHighlight()), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-tree__item-container--active"), hasNavigation || active), (0, _defineProperty2.default)(_classnames, 'is-navigated', isNavigated), (0, _defineProperty2.default)(_classnames, 'is-selected', (rest === null || rest === void 0 ? void 0 : rest.selection) === 'multi' && isSelected), _classnames));
  var buttonClasses = classnames("".concat(cssNamespace, "-tree__expander"), {
    'is-expanded': !!isExpanded
  });
  var contentClasses = classnames("".concat(cssNamespace, "-tree__content"), (0, _defineProperty2.default)({}, "".concat(cssNamespace, "-tree__content--wrap"), wrapContent), {
    'has-navigation-indicator': hasNavigation && !(rest !== null && rest !== void 0 && rest.treeActive)
  });
  var branchClasses = classnames("".concat(cssNamespace, "-tree"), {
    'is-hidden': level > 1 && !isExpanded
  });

  var nodeContent = /*#__PURE__*/_react.default.createElement("span", {
    className: classnames("".concat(cssNamespace, "-tree__text"))
  }, nodeContentPayload);

  var checkBox;
  var radioItem;
  var selectionControlId = "".concat(nodeId, "-selection-control");

  if ((rest === null || rest === void 0 ? void 0 : rest.selection) === 'multi') {
    var _ref2 = selectionProps || {},
        _onChange = _ref2.onChange;

    checkBox = /*#__PURE__*/_react.default.createElement(_Checkbox.default, (0, _extends2.default)({
      ariaLabel: nodeTextContent
    }, selectionProps, {
      id: selectionControlId,
      onChange: function onChange(event, checked) {
        _onChange && _onChange(event, checked);
        onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange(event, checked, nodeData);
        setSelected(checked);
      }
    }));
  } else if ((rest === null || rest === void 0 ? void 0 : rest.selection) === 'single') {
    var _ref3 = selectionProps || {},
        name = _ref3.name;

    var radioItemName = rest === null || rest === void 0 ? void 0 : rest.treeId;

    var _ref4 = (selectionProps === null || selectionProps === void 0 ? void 0 : selectionProps.inputProps) || {},
        _onChange2 = _ref4.onChange;

    radioItem = /*#__PURE__*/_react.default.createElement(_FormRadioItem.default, (0, _extends2.default)({
      children: ""
    }, selectionProps, {
      id: selectionControlId,
      inputProps: _objectSpread(_objectSpread({
        'aria-label': nodeTextContent
      }, selectionProps === null || selectionProps === void 0 ? void 0 : selectionProps.inputProps), {}, {
        onChange: function onChange(event) {
          _onChange2 && _onChange2(event); // always return true because radio item change is only triggered on selection not de-selection

          onSelectionChange && onSelectionChange(event, true, nodeData);
        }
      }),
      name: name ? name : radioItemName
    }));
  }

  var expansionEventBubbler = rest.expansionEventBubbler,
      removeLevel = rest.level,
      parentId = rest.parentId,
      parentPath = rest.parentPath,
      selectionPosition = rest.selectionPosition,
      treeId = rest.treeId,
      treeActive = rest.treeActive,
      otherProps = (0, _objectWithoutProperties2.default)(rest, ["expansionEventBubbler", "level", "parentId", "parentPath", "selectionPosition", "treeId", "treeActive"]);

  var renderIcons = function renderIcons(icons) {
    return icons && (icons === null || icons === void 0 ? void 0 : icons.length) && (icons === null || icons === void 0 ? void 0 : (0, _map.default)(icons).call(icons, function (icon, index) {
      return /*#__PURE__*/_react.default.createElement(_Icon.default, {
        className: classnames("".concat(cssNamespace, "-tree__icon")),
        glyph: icon,
        key: index
      });
    })) || '';
  };

  var buttonId = "".concat(nodeId, "-expansion-toggle-button");
  var subTreeId = "".concat(nodeId, "-subtree-root");
  return /*#__PURE__*/_react.default.createElement("li", (0, _extends2.default)({}, otherProps, {
    "aria-expanded": isExpanded,
    "aria-level": level,
    className: nodeClasses,
    id: nodeId,
    role: "treeitem"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: containerClasses
  }, (nodeChildren === null || nodeChildren === void 0 ? void 0 : nodeChildren.length) > 0 && /*#__PURE__*/_react.default.createElement("button", {
    "aria-controls": nodeId,
    "aria-label": isExpanded ? 'collapse' : 'expand',
    "aria-pressed": isExpanded,
    className: buttonClasses,
    id: buttonId,
    onClick: handleButtonClick
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    ariaHidden: true,
    className: classnames('fd-tree__icon'),
    glyph: isExpanded ? 'navigation-down-arrow' : 'navigation-right-arrow'
  })), renderIcons(glyphsBefore), rest.selectionPosition === 'left' && (rest === null || rest === void 0 ? void 0 : rest.selection) === 'single' && radioItem, rest.selectionPosition === 'left' && (rest === null || rest === void 0 ? void 0 : rest.selection) === 'multi' && checkBox, hasNavigation ? /*#__PURE__*/_react.default.createElement("a", {
    className: contentClasses,
    href: link
  }, nodeContent) : /*#__PURE__*/_react.default.createElement("div", {
    className: contentClasses
  }, nodeContent), renderIcons(glyphsAfter), actions, rest.selectionPosition === 'right' && (rest === null || rest === void 0 ? void 0 : rest.selection) === 'single' && radioItem, rest.selectionPosition === 'right' && (rest === null || rest === void 0 ? void 0 : rest.selection) === 'multi' && checkBox), (nodeChildren === null || nodeChildren === void 0 ? void 0 : nodeChildren.length) > 0 && /*#__PURE__*/_react.default.createElement("ul", {
    "aria-hidden": !isExpanded,
    className: branchClasses,
    id: subTreeId,
    role: "group"
  }, nodeChildren));
};

TreeNode.displayName = 'Tree.Node';
process.env.NODE_ENV !== "production" ? TreeNode.propTypes = {
  /** React nodes to render as `TreeNode`s actions. Expecting `Button`s here.*/
  actions: _propTypes.default.node,

  /** Set to **true** to make this particular `TreeNode` have styles for interaction states (hover, selected, active).*/
  active: _propTypes.default.bool,

  /** React nodes to render within. Nest `TreeNode`s to create multiple levels in the `Tree`.*/
  children: _propTypes.default.node,

  /** Custom classes to add to TreeNode.*/
  className: _propTypes.default.string,

  /** An **Array of string** values to representing icon names to display before node contents.*/
  glyphsAfter: _propTypes.default.arrayOf(_propTypes.default.string),

  /** An **Array of string** values to representing icon names to display before after contents.*/
  glyphsBefore: _propTypes.default.arrayOf(_propTypes.default.string),

  /** Set to one of the valid values to highlight the row with the corresponding semantic color.*/
  highlight: _propTypes.default.oneOf(['default', 'error', 'success', 'warning']),

  /** Set to a **String** value to use as id for this node which is a `<li>`. If unset, a generate value will be used.*/
  id: _propTypes.default.string,

  /** Set to **true** to show styles representing that the node has been navigate to.*/
  isNavigated: _propTypes.default.bool,

  /** Set to a **String**  value to use as href and make this node an `<a>` tag with appropriate styles.*/
  link: _propTypes.default.string,

  /** **Object** to be received in the `onExpandToggle` and `onSelectionChange` callbacks of this node.*/
  nodeData: _propTypes.default.object,

  /** Additional props to be spread to the selection control, if any.*/
  selectionProps: _propTypes.default.object,

  /** Set to **true** to make node contents wrap to next line(s).*/
  wrapContent: _propTypes.default.bool,

  /**
   * Callback function; triggered when a node's expansion button is clicked.
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {Boolean} expansion - Boolean representing if this event will expand TreeNode's subtree.
   * @param {Object} nodeData - TreeNode.nodeData
   * @returns {void}
  */
  onExpandToggle: _propTypes.default.func,

  /**
   * Callback function; triggered when a node is selected (if selection is enabled)
   *
   * * multi: selection state changes
   * * single: is selected
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {Boolean} checked - Boolean representing if this event will select the TreeNode.
   * This is always true for single select Tree's because this event is only fired on radio selection.
   * @param {Object} nodeData - TreeNode.nodeData
  */
  onSelectionChange: _propTypes.default.func
} : void 0;

var _default = (0, _withStyles.default)(TreeNode);

exports.default = _default;